import { defineComponent as _defineComponent } from 'vue'
import { watch, computed } from 'vue';
import store from '@/store';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';

import ImageEffectsPropertiesModalsAddHeader from './components/header/ImageEffectsPropertiesCreateHeader.vue';
import ImageEffectsPropertiesModalsAddBody from './components/body/ImageEffectsPropertiesCreateBody.vue';
import ImageEffectSelectedBody from './components/body/ImageEffectSelectedBody.vue';
import { createEffectFromPreset } from '../../utils/effectCreators';
import { ImageEffectType } from '@/typings/customilyElements/imageEffectType';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesCreate',
  emits: ["update"],
  setup(__props, { emit }: { emit: ({
    (event: 'update', value: ImageEffectType, newData?: ImageEffectType): void;
}), expose: any, slots: any, attrs: any }) {



const isOpen = computed(() => {
    return store.state.imageEffectsProperties?.modalAddIsOpen || false;
});
const selectedEffect = computed(() => {
    return store.state.imageEffectsProperties?.selectedImageEffect;
});

const handleUpdate = (newData: ImageEffectType, id?: string) => {
    let effect;
    if (!selectedEffect.value?.formData) {
        const presetSelected = selectedEffect.value?.presets?.find((preset) => preset.id === id);
        if (presetSelected) effect = createEffectFromPreset(presetSelected);
        store.dispatch('imageEffectsProperties/addImageEffect', effect);
    } else {
        effect = selectedEffect.value.formData;
    }
    if (effect) emit('update', effect, newData);
};

const handleClose = () => {
    store?.dispatch('imageEffectsProperties/closeAddModal');
};

const resetForm = () => {
    store.dispatch('imageEffectsProperties/resetModalState');
};

watch(
    () => isOpen.value,
    () => {
        if (!isOpen.value) {
            resetForm();
        }
    }
);

return { __sfc: true,emit, isOpen, selectedEffect, handleUpdate, handleClose, resetForm, CModal, CButton, ImageEffectsPropertiesModalsAddHeader, ImageEffectsPropertiesModalsAddBody, ImageEffectSelectedBody }
}

})